import React from 'react'
import "./profileVerification.scss"
function ProfileVerification() {
    return (
        <div className='profile-verification'>ProfileVerification </div>
    )
}

export default ProfileVerification